import React from 'react';

import './index.scss';

import Container from '../../../../components/Container'
import CompanyFeature from '../CompanyFeature'
import Section from '../../../../components/Section'

import brazil from '../../../../assets/advantages/brazil.svg'
import cloud from '../../../../assets/advantages/cloud.svg'
import graph from '../../../../assets/advantages/graph.svg'
import graphs from '../../../../assets/advantages/graphs.svg'
import cube from '../../../../assets/advantages/cube.svg'

const Advantages = () => {
  const features = [
    { image: brazil, imageSize: 200, title: <p>Advogados do brasil a um clique</p>, text: <p>Ao cadastrar um caso na plataforma, nosso sistema automaticamente envia uma mensagem para o advogado da outra parte, convidando-o para negociar.</p> },
    { image: cube, imageSize: 220, title: <p>Concentração em um único local</p>, text: <p>Toda a cadeia de negociação é feita através da nossa plataforma, desde a mensagem inicial até a inserção do comprovante de protocolo, incluindo a inserção de minuta, facilitando a visualização do fluxo.</p> },
    { image: graph, imageSize: 180, title: <p>Entenda e melhore a política de acordo</p>, text: <p>Nosso dashboard disponibiliza as métricas de negociação por período, estado, escritório, além de valores economizados e ticket médio para uma interpretação e otimização da política de acordo baseada em dados.</p> },
    { image: graphs, imageSize: 220, title: <p>Acompanhe as negociações dos seus escritórios em tempo real</p>, text: <p>Todas as empresas e grupos possuem logins mestres, através do qual podem visualizar todos os escritórios vinculados, acompanhando as negociações feitas por eles em tempo real.</p> },
    { image: cloud, imageSize: 160, title: <p>Registre todas as suas negociações e tenha o histórico completo</p>, text: <p>O armazenamento de casos na conta de cada usuário permite que as mensagens trocadas fiquem armazenadas para eventuais consultas.</p> }
  ]

  return (
    <Container id="Advantages">
      <Section
        name="Vantagens"
        title="Conheça as nossas vantagens"
        text="O Com Acordo é uma plataforma de negociação online, exclusiva e gratuita para advogados. A negociação é conduzida diretamente pelas partes através do chat, abrangendo toda a cadeia de tratativas. Entenda algumas das vantagens da plataforma." />
      <div className='features'>
        {features.map(({ image, imageSize, title, text, flexDirection }) => (
          <CompanyFeature image={image} imageSize={imageSize} title={title} text={text} flexDirection={flexDirection} />
        ))}
      </div>
    </Container>
  )
}

export default Advantages
